import { Link, useNavigate } from "react-router-dom";
import footerLogo from "../ui-assets/home/eventfork_white_logo.svg";
import createPlusicon from "../ui-assets/home/create-event-plus.svg";

const MainFooter = () => {
  const navigate = useNavigate();
  const handleCreateEvent = () => {
    navigate("/create-event");
  };
  return (
    <footer className="landing-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-column">
            <Link to="/">
            <img
              src={footerLogo}
              alt="logo"
              className="footer-logo"
              style={{ margin: "0px 0px 18px" }}
            />
            </Link>
            <p>
              Your ultimate destination for discovering and creating amazing
              events in your city.
            </p>

        
          </div>

          <div className="footer-column">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <button
                  type="button"
                  className="link-button"
                  onClick={() => window.location.href = '/'}
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="link-button"
                  onClick={() => window.location.href = '/all-event'}
                >
                  Browse Events
                </button>

                
              </li>
              <li>
                <button
                  type="button"
                  className="link-button"
                  onClick={handleCreateEvent}
                >
                  Create Event
                </button>
              </li>
              {/* <li>
                <button
                  type="button"
                  className="link-button"
                  onClick={() => window.location.href = '/pricing'}
                >
                  Pricing
                </button>
              </li> */}
              {/* <li>
                <button
                  type="button"
                  className="link-button"
                  onClick={() => window.location.href = '/blog'}
                >
                  Blog
                </button>
              </li> */}
            </ul>
          </div>

          <div className="footer-column">
            <h3>Support</h3>
            <ul>
              {/* <li>
                <Link to="/help-center" className="link-button">
                  Help Center
                </Link>
              </li> */}
              <li>
                <Link to="/contact" className="link-button">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="link-button">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="link-button">
                  Terms of Service
                </Link>
              </li>

              <li>
                <Link to="/faq" className="link-button">
                  FAQ
                </Link>
              </li>

              <li>
                <Link to="/help" className="link-button">
                  Help Center
                </Link>
              </li>


            </ul>
          </div>

          <div className="footer-column">
            <h3>Connect With Us</h3>
            <ul>






              <li>
                <a
                  href="https://www.instagram.com/eventfork_"
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-instagram" /> Instagram
                </a>
              </li>


              <li>
                <a
                  href="https://www.linkedin.com/company/eventfork"
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-linkedin-in" /> LinkedIn
                </a>
              </li>


              <li>
                <a
                  href="https://www.facebook.com/profile.php?id=61590536038157"
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-facebook-f" /> Facebook
                </a>
              </li>

             <li>
             <a
    href="https://www.x.com/eventfork_2025"
    className="social-link"
    target="_blank"
    rel="noopener noreferrer"
>
<svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      fill="currentColor"
      viewBox="0 0 16 16"
      style={{ verticalAlign: "middle", marginRight: "4px" }}
>
<path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
</svg>
    X
</a>
</li>


            </ul>
          </div>
        </div>

        <div className="copyright">
          <p>© 2026 EventFork. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default MainFooter;
